import React from 'react';

import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CircularProgress from '@material-ui/core/CircularProgress';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: 160
  }
}));

const Loading = () => {
  const classes = useStyles();

  return (
    <Card className={classes.root}>
      <CardContent>
        <CircularProgress size={30} />
      </CardContent>
    </Card>
  );
};

export default Loading;
